import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { reactSelectStyles } from "./ReactSelectStyles";

const FormMultiSelect = ({
  field,
  value = [],
  handleChange,
  options = [],
  placeholder = "Select option(s)",
  error = null,
  disabled = false,
}) => {

  // React-select options
  const reactSelectOptions = options.map(opt => ({
    value: opt.value,
    label: opt.label
  }));

  // Selected options (array)
  const selectedOptions = reactSelectOptions.filter(opt =>
    Array.isArray(value) && value.includes(opt.value)
  );

  // Handle change
  const handleReactSelectChange = (selected) => {
    const selectedValues = selected
      ? selected.map(opt => opt.value)
      : [];

    if (handleChange) {
      handleChange({
        target: {
          name: field.name,
          value: selectedValues
        }
      });
    }
  };

  // Styles with error
  const getStylesWithError = () => ({
    ...reactSelectStyles,
    control: (provided, state) => {
      const base = reactSelectStyles.control(provided, state);
      return error
        ? {
          ...base,
          borderColor: "#dc3545",
          "&:hover": { borderColor: "#dc3545" }
        }
        : base;
    }
  });

  return (
    <div className={field.fieldSize || "col-12"}>
      {!field.labelHide && (
        <label className={`form-label text-capitalize text-muted ${field.labClass || ""}`}>
          {field.label}
          {field.required && <span className="text-danger small"> *</span>}
        </label>
      )}

      <Select
        name={field.name}
        value={selectedOptions}
        onChange={handleReactSelectChange}
        options={reactSelectOptions}
        placeholder={placeholder}
        isMulti
        isClearable
        isSearchable
        isDisabled={disabled || field.disabled}
        className={`react-select-container ${error ? "is-invalid" : ""}`}
        classNamePrefix="react-select"
        menuPosition="fixed"
        menuPortalTarget={typeof window !== "undefined" ? document.body : null}
        styles={{
          ...getStylesWithError(),
          menuPortal: base => ({ ...base, zIndex: 9999 }),
        }}
      />

      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

FormMultiSelect.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.array,
  handleChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

FormMultiSelect.defaultProps = {
  value: [],
  options: [],
  placeholder: "Select option(s)",
  error: null,
  disabled: false,
};

export default FormMultiSelect;
